document.addEventListener('DOMContentLoaded', () => {
	// mobile menu
	document.querySelectorAll('.menu-icon').forEach(menuIcon => {
		menuIcon.addEventListener('click', () => {
			const isActive = menuIcon.classList.toggle('active');
			const parentElement = menuIcon.parentElement.parentElement;
			const menuContainer = Array.from(parentElement.children).find(child =>
				/^menu-.*-container$/.test(child.className)
			);

			// Handle Mega Menu and Overlay
			if (menuContainer) {
				const megaMenu = menuContainer.querySelector('.mega-menu');
				if (megaMenu) {
					megaMenu.classList.toggle('active');
					if (megaMenu.classList.contains('active')) {
						// Calculate total height of header and alert bar
						const adminBar = document.getElementById('wpadminbar');
						const siteHeader = document.querySelector('.site-header');
						const alertBar = document.querySelector('.wp-block-knightowl-blocks-alert-bar');
						let totalHeight = 100; // initial offset
						if (adminBar) {
							totalHeight += adminBar.offsetHeight;
						}
						if (siteHeader) {
							totalHeight += siteHeader.offsetHeight;
						}
						if (alertBar) {
							totalHeight += alertBar.offsetHeight;
						}

						// Set padding bottom of mega menu
						megaMenu.style.paddingBottom = `${totalHeight}px`;

						// Create and append overlay
						const overlay = document.createElement('div');
						overlay.id = 'menu-overlay';
						document.body.appendChild(overlay);
					} else {
						// Remove max-height from mega menu
						megaMenu.style.paddingBottom = '';

						// Remove overlay
						const overlay = document.getElementById('menu-overlay');
						if (overlay) {
							overlay.remove();
						}
					}
				}
			}

			if (isActive) {
				document.body.classList.add('mobile-menu-open');
			} else {
				document.body.classList.remove('mobile-menu-open');
				document.querySelectorAll('.menu-links-open').forEach(li => {
					li.classList.remove('menu-links-open');
				});
				document.querySelectorAll('.open-menu-links[aria-expanded="true"]').forEach(link => {
					link.setAttribute('aria-expanded', 'false');
				});
			}
		});
	});

	document.querySelectorAll('.open-menu-links').forEach(openMenuLink => {
		openMenuLink.addEventListener('click', (event) => {
			event.preventDefault();

			// Close all open menu links except the current one
			document.querySelectorAll('.menu-links-open').forEach(li => {
				if (li !== openMenuLink.closest('li')) {
					li.classList.remove('menu-links-open');
					const linkInLi = li.querySelector('.open-menu-links');
					if (linkInLi) {
						linkInLi.setAttribute('aria-expanded', 'false');
					}
				}
			});

			// Toggle the current menu link
			let parentLi = openMenuLink.closest('li');
			if (parentLi) {
				parentLi.classList.toggle('menu-links-open');
			}
			let ariaExpanded = openMenuLink.getAttribute('aria-expanded');
			openMenuLink.setAttribute('aria-expanded', ariaExpanded === 'true' ? 'false' : 'true');
		});
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			closeActiveMenus();
		}
	});

	// Close menu when clicking on any link within the mega menu (except open-menu-links)
	document.querySelectorAll('.mega-menu a:not(.open-menu-links)').forEach(link => {
		link.addEventListener('click', () => {
			// Only close if mobile menu is open and link contains a hash
			if (document.body.classList.contains('mobile-menu-open') && link.href.includes('#')) {
				closeActiveMenus();
			}
		});
	});

	// Auto collapse: detect when menu items overflow and switch to mobile mode
	function checkMenuOverflow() {
		document.querySelectorAll('[data-auto-collapse]').forEach(wrapper => {
			const menu = wrapper.querySelector('.mega-menu');
			if (!menu) return;

			// Below md breakpoint — CSS handles mobile, clean up
			if (window.innerWidth < 782) {
				wrapper.classList.remove('mega-menu-overflow');
				document.body.classList.remove('mega-menu-overflow');
				return;
			}

			// Remove overflow class so desktop styles apply for measurement
			wrapper.classList.remove('mega-menu-overflow');
			document.body.classList.remove('mega-menu-overflow');
			void document.body.offsetHeight;

			const allItems = Array.from(menu.querySelectorAll(':scope > li:not(.mobile-only)'));
			if (allItems.length < 2) return;

			// Prevent shrinking to measure natural item widths
			allItems.forEach(item => { item.style.flexShrink = '0'; });
			void menu.offsetHeight;

			// Use getBoundingClientRect for sub-pixel precision (avoids integer rounding gaps)
			const gap = parseFloat(getComputedStyle(menu).columnGap) || 0;
			let totalItemsWidth = 0;
			allItems.forEach(item => { totalItemsWidth += item.getBoundingClientRect().width; });
			totalItemsWidth += gap * (allItems.length - 1);
			const containerWidth = menu.getBoundingClientRect().width;
			const isOverflowing = totalItemsWidth > containerWidth;

			// Restore
			allItems.forEach(item => { item.style.flexShrink = ''; });

			if (isOverflowing) {
				// Measure a menu item's height (text + padding) — this is what sets the header row height
				const firstItem = menu.querySelector(':scope > li:not(.search-modal):not(.mobile-only)');
				if (firstItem) {
					wrapper.style.setProperty('--mega-menu-overflow-height', `${firstItem.getBoundingClientRect().height}px`);
				}

				wrapper.classList.add('mega-menu-overflow');
				document.body.classList.add('mega-menu-overflow');
			}
		});
	}

	// Run overflow check immediately, and again after fonts/images load
	checkMenuOverflow();
	document.fonts.ready.then(checkMenuOverflow);
	window.addEventListener('load', checkMenuOverflow);

	let windowWidth = window.innerWidth;
	window.addEventListener('resize', () => {
		// Check if window width has actually changed (to avoid iOS resize event on scroll)
		if (window.innerWidth !== windowWidth) {
			// Update the window width for next time
			windowWidth = window.innerWidth;

			// Close active menus
			closeActiveMenus();

			// Re-check overflow
			checkMenuOverflow();
		}
		// Otherwise do nothing
	});

	// hover intent
	const showDelay = 200;
	const hideDelay = 500;
	let menuEnterTimer, menuLeaveTimer;
	let hasMoved = false;

	// Simple flag to track if mouse has moved
	document.addEventListener('mousemove', () => {
		hasMoved = true;
	}, { once: true });

	document.querySelectorAll('.mega-menu').forEach(menu => {
		const allMenuItems = menu.querySelectorAll('li.has-mega-menu-panel');

		allMenuItems.forEach(item => {
			if (item.parentElement === menu) {
				const anchor = item.querySelector(':scope > a, :scope > div > a');

				const addActiveState = () => {
					if (!hasMoved) return;
					if (menu.closest('.mega-menu-overflow')) return;

					allMenuItems.forEach(innerItem => {
						innerItem.classList.remove('active');
						const innerAnchor = innerItem.querySelector(':scope > a, :scope > div > a');
						if (innerAnchor) {
							innerAnchor.setAttribute('aria-expanded', 'false');
						}
					});

					item.classList.add('active');
					if (anchor) {
						anchor.setAttribute('aria-expanded', 'true');
					}
				};

				const removeActiveState = () => {
					item.classList.remove('active');
					if (anchor) {
						anchor.setAttribute('aria-expanded', 'false');
					}
				};

				// Mouse events
				item.addEventListener('mouseenter', () => {
					clearTimeout(menuLeaveTimer);
					menuEnterTimer = setTimeout(addActiveState, showDelay);
				});

				item.addEventListener('mouseleave', () => {
					clearTimeout(menuEnterTimer);
					menuLeaveTimer = setTimeout(removeActiveState, hideDelay);
				});

				// Keyboard events
				item.addEventListener('focus', () => {
					clearTimeout(menuLeaveTimer);
					menuEnterTimer = setTimeout(addActiveState, showDelay);
				}, true);

				item.addEventListener('blur', () => {
					clearTimeout(menuEnterTimer);
					menuLeaveTimer = setTimeout(removeActiveState, hideDelay);
				}, true);
			}
		});
	});
});

function closeActiveMenus() {
	document.querySelectorAll('.menu-icon.active, .mega-menu.active, li.has-mega-menu-panel.active').forEach(element => {
		element.classList.remove('active');
		if (element.classList.contains('mega-menu')) {
			element.style.paddingBottom = '';
		}
	});

	document.body.classList.remove('mobile-menu-open');

	const overlay = document.getElementById('menu-overlay');
	if (overlay) {
		overlay.remove();
	}

	document.querySelectorAll('li.menu-links-open').forEach(liElement => {
		liElement.classList.remove('menu-links-open');
	});

	document.querySelectorAll('.open-menu-links[aria-expanded="true"]').forEach(element => {
		element.setAttribute('aria-expanded', 'false');
	});
}
